import { render } from "./WorkLoadPrepareDialog.vue?vue&type=template&id=9388bd64"
import script from "./WorkLoadPrepareDialog.vue?vue&type=script&lang=js"
export * from "./WorkLoadPrepareDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__